import React from 'react';
import { config } from '@triare/auth-redux';
import Simple from '../../../components/Layout/Simple';
import OTPLinkConfirm from '../../../components/Pages/Auth/SignIn/OTPLink';

const { displayName } = config;

export default function ConfirmOTP(): React.ReactNode {
  document.title = `${displayName}: Confirm OTP`;

  return (
    <Simple>
      <OTPLinkConfirm />
    </Simple>
  );
}
